import React from "react";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import AppShell from "@/AppShell";

export default function App() {
    return (
        <HelmetProvider>
            <BrowserRouter>
                <AppShell />
            </BrowserRouter>
        </HelmetProvider>
    );
}
